// Bytes to base64 and back, fast enough for notes of megabytes: going
// through a string of one character per byte froze the page for a large note.

const ALPHABET = new TextEncoder().encode(
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
);
const PAD = '='.charCodeAt(0);

export const toBase64 = (bytes: Uint8Array) => {
  const out = new Uint8Array(Math.ceil(bytes.length / 3) * 4);
  const put = (at: number, n: number, chars: number) => {
    for (let c = 0; c < 4; c++) {
      out[at + c] = c < chars ? ALPHABET[(n >> (18 - 6 * c)) & 63] : PAD;
    }
  };
  let i = 0;
  for (; i + 2 < bytes.length; i += 3) {
    put(i / 3 * 4, (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2], 4);
  }
  const rest = bytes.length - i;
  if (rest) {
    put(
      i / 3 * 4,
      (bytes[i] << 16) | (rest === 2 ? bytes[i + 1] << 8 : 0),
      rest + 1,
    );
  }
  return new TextDecoder().decode(out);
};

export const fromBase64 = (text: string) => {
  const binary = atob(text);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
};
